module.exports = __webpack_public_path__ + "static/media/cove.7aefb696.jpg";